import "../scss/main.scss";

(function ($) {
    $(document).ready(function () {
        theme.init();
    });

    var theme = {
        init: function () {
            this.xhr = false;
            this.ajaxLoadingClass = "ajax-loading";
            this.ajaxModal = $("#ajax-content-modal");
            this.headerFunctions();
            //this.subMenu();
            this.runSliders();
            this.ajaxContent();
            this.ajaxContentModal();
            this.toggleFilters();
            this.tabs();
            this.departments();
            this.shopsModal();
            this.refreshMapTrigger();
            this.departmentTabs();
            this.filters();
            this.backToTop();
            this.share();
            this.upload();
            this.updateCartCounter();
            this.removeCartItem();
            this.warningModal();

            $("a.gradient-btn").on("click", function (e) {
                e.preventDefault();
                var href = $(this).attr("href");
                $("html, body").animate(
                    {
                        scrollTop: $(href).offset().top - 130,
                    },
                    1200
                );
            });

            $("#formularz form.wpcf7-form").on("submit", function () {
                $(this).hide();
                $("#thankyou").fadeIn();
            });

            $("#totalpoll .totalpoll-question-choices-item-control").on("click", function () {
                var targetElement = $(".totalpoll-form-custom-fields");

                var offset = targetElement.offset().top - 100;
                $("html, body").animate(
                    {
                        scrollTop: offset,
                    },
                    500
                );
            });
        },

        updateCartCounter: function () {
            $(document.body).on("wc_fragment_refresh updated_wc_div", function () {
                let args = {
                    action: "get_cart_button",
                };
                $.ajax({
                    url: themeSettings.ajaxurl,
                    method: "post",
                    data: args,

                    success: function (response) {
                        $("a.cart").html(response);
                    },
                });
            });
        },

        departmentTabs: function () {
            $(document).on("click", ".department-header", function (e) {
                e.preventDefault();
                $(".department").removeClass("active");
                $(this).closest(".department").addClass("active");
            });

            if ($(window).width() < 768) {
                $(".department").removeClass("active");
            }

            $("#departments .regions-map ul.regions-list li").mouseover(function () {
                let tabRegion = $(this).attr("data-show_region");

                $("#map .region").each(function () {
                    let mapRegion = $(this).attr("data-show_region");
                    if (mapRegion == tabRegion) {
                        $(this).addClass("active");
                    }
                });
            });

            $("#departments .regions-map ul.regions-list li").mouseleave(function () {
                $("#map .region").removeClass("active");
            });
        },

        refreshMapTrigger: function () {
            var _this = this;
            $(document).on("click", "[data-refresh_map]", function () {
                $(".cpro-map").each(function () {
                    let id = $(this).data("cpro_map");
                    _this.refreshMapView(id);
                });
            });
        },

        refreshMapView: function (mapId) {
            let mapObject = window.maps[mapId];
            if (mapObject && mapObject.map) {
                setTimeout(() => {
                    mapObject.map.invalidateSize();
                    mapObject.map.fitBounds(mapObject.bounds);
                }, 20);
            }
        },

        shopsModal: function () {
            var _this = this;
            var modal = $("#shops-modal");
            $(document).on("click", "[data-shops_modal]", function (e) {
                e.preventDefault();
                let type = $(this).data("shops_modal");
                modal.find("#tabs").tabs({
                    active: type,
                });
                let map = modal.find(".cpro-map");
                let mapId = map.data("cpro_map");
                _this.refreshMapView(mapId);

                modal.modal({
                    position: ["10%"],
                });
            });
        },

        warningModal: function() {

            $(document).on("click", "a.warning-link", function (e) {
                e.preventDefault();
                $('#warnings').addClass('visible');
            });

            $(document).on("click", "#warnings .simplemodal-close", function (e) {
                e.preventDefault();
                $('#warnings').removeClass('visible');
            });
        },

        departments: function () {
            var _this = this;
            var modal = $("#contact-modal");
            var modalContent = modal.find(".modal-content");
            $(document).on("click", "[data-show_region]", function (e) {
                e.preventDefault();
                let regionId = $(this).data("show_region");
                let departmentId = $(this).closest("[data-department_id]").data("department_id");
                modalContent.html('<div class="loader"></div>');
                modal.modal({
                    position: ["10%"],
                });

                var args = {
                    action: "get_ajax_content",
                    content: "region",
                    department: departmentId,
                    region: regionId,
                };

                _this.xhr = $.ajax({
                    url: themeSettings.ajaxurl,
                    dataType: "html",
                    method: "post",
                    data: args,
                    beforeSend: function () {
                        if (_this.xhr) {
                            _this.xhr.abort();
                        }
                    },
                    success: function (response) {
                        modalContent.html(response);
                    },
                });
            });
        },

        headerFunctions: function () {
            $("a.toggle-search").click(function (e) {
                e.preventDefault();
                $("#searchform").slideToggle();
            });

            if ($(window).width() <= 1024) {

                $(".toggle-nav").click(function (e) {
                    e.preventDefault();
                    $("div#mobile-menu").addClass("toggled");
                    $("body").addClass("fixed-position");
                });

                $(".close").click(function (e) {
                    e.preventDefault();
                    $("div#mobile-menu").removeClass("toggled");
                    $("body").removeClass("fixed-position");
                });

                $("div#mobile-menu .menu > li.menu-item-has-children").append(
                    '<span class="chevron"></span>'
                );

                $("div#mobile-menu .menu li.menu-item-has-children").click(function () {
                    $(this).find(".sub-menu, .chevron").toggleClass("opended");
                });
            }

            $(window).scroll(function () {
                if ($(this).scrollTop() > 250) {
                    $("header:not(.woocommerce-products-header)").addClass("fixed");
                    $('body').addClass('scrolling');
                } else {
                    $("header:not(.woocommerce-products-header)").removeClass("fixed");
                    $('body').removeClass('scrolling');
                }
            });

            $(document).on("click", "a.cart-btn", function (e) {
                e.preventDefault();
                $("#my-mini-cart").css('opacity', '1').addClass("visible");
                $("#overlay").fadeIn().css('background-color', 'transparent').css('z-index', '1');
                $('body').addClass('fixed');
            });

            $(document).on("click", "#my-mini-cart a.close, #overlay", function (e) {
                e.preventDefault();
                $("#my-mini-cart").css('opacity', '0').removeClass("visible");
                $("header .container .navbar").removeClass('product-added');
                $('body').removeClass("fixed");
                $("#overlay").fadeOut();
                setTimeout(function() {
                    $("#overlay").css('background-color', 'rgba(0, 0, 0, 0.5)').css('z-index', '2');
                }, 400);
            });

            $(document.body).on('added_to_cart', function() {
                setTimeout(function() {
                    $("#my-mini-cart").addClass('visible'); 
                    $("#overlay").fadeIn();
                    $('body').addClass('fixed');
                }, 200);
            }); 

            var miniCartWasVisible = false;

            $(document.body).on("wc_fragment_refresh", function () {
              miniCartWasVisible = $("#my-mini-cart").hasClass("visible");
            });
      
            $(document.body).on("wc_fragments_refreshed", function () {
              if (miniCartWasVisible) {
                $("#my-mini-cart").addClass("visible");
                $("#overlay").show();
              }
            });

        },

        removeCartItem: function () {
            $(document).on("click", ".remove-me", function (e) {
              e.preventDefault();
              $('#my-mini-cart').addClass('loading');
              var product_id = $(this).data("product_id");
              var cart_item_key = $(this).data("cart_item_key");
              var product_sku = $(this).data("product_sku");
      
              var data = {
                action: "remove_cart_item",
                product_id: product_id,
                cart_item_key: cart_item_key,
                product_sku: product_sku,
              };
      
              $.post(wc_add_to_cart_params.ajax_url, data, function (response) {
                if (response) {
                  $(document.body).trigger("wc_fragment_refresh");
                  $('#my-mini-cart').removeClass('loading');
                }
              });
            });
          },

        subMenu: function () {
            if ($(window).width() > 1024) {
                $(
                    "header .navbar .main-menu-container .menu li.products-menu-item, header .products-sub-menu"
                ).mouseover(function () {
                    $("header .products-sub-menu").addClass("opended");
                });

                $(
                    "header .navbar .main-menu-container .menu li.products-menu-item, header .products-sub-menu"
                ).mouseleave(function () {
                    $("header .products-sub-menu").removeClass("opended");
                });

                $("header .container .navbar .menu li.menu-item-has-children").mouseover(function () {
                    $(this).find(".sub-menu").addClass("opended");
                });

                $("header .container .navbar .menu li.menu-item-has-children").mouseleave(function () {
                    $(this).find(".sub-menu").removeClass("opended");
                });
            } else {
                $("header .navbar .main-menu-container .menu li.products-menu-item").click(function (e) {
                    e.preventDefault();
                    $("header .products-sub-menu").addClass("opended");
                });

                $(".products-sub-menu .mobile a.goback").click(function (e) {
                    e.preventDefault();
                    $(this).parent().parent().removeClass("opended");
                });

                $(".product_category span.chevron").click(function (e) {
                    e.preventDefault();
                    $(this).toggleClass("opened");
                    $(this).parent().parent().find("a:not(.submenu-title)").toggleClass("opened");
                });

                $(".brands-filter span.chevron").click(function (e) {
                    e.preventDefault();
                    $(this).toggleClass("opened");
                    $(this).parent().find("ul.brand-filter").toggleClass("opened");
                });
            }
        },

        ajaxContentModal: function () {
            var _this = this;

            $(document).on("click", "[data-dismiss_modal]", function (e) {
                e.preventDefault();
                _this.ajaxModal.hide();
            });

            $(document).on("click", ".modal-dialog", function (e) {
                _this.ajaxModal.hide();
            });

            $(document).on("click", ".modal-inner", function (e) {
                e.stopPropagation();
            });

            $(document).on("click", "[data-ajax_content_modal]", function (e) {
                e.preventDefault();
                const element_id = $(this).data("ajax_content_modal");

                var args = {
                    action: "get_ajax_content",
                    content: element_id,
                };

                var single_item_id = $(this).data("id");
                if (single_item_id) args.id = single_item_id;

                _this.ajaxModal.find("[data-modal_body]").html("");
                _this.ajaxModal.show();

                _this.xhr = $.ajax({
                    url: themeSettings.ajaxurl,
                    dataType: "html",
                    method: "post",
                    data: args,
                    beforeSend: function () {
                        if (_this.xhr) {
                            _this.xhr.abort();
                        }
                    },
                    success: function (response) {
                        _this.ajaxModal.find("[data-modal_body]").html(response);
                    },
                });
            });
        },

        runSliders: function () {
            this.heroSlider();
            this.brandsSlider();
            this.productsSlider();
            this.productImages();
            this.inspirationsSlider();
            this.postsSlider();
            this.arrowsWrap();

            if ($(window).width() < 1200) {
                // $('.homepage-products .types .categories').slick({
                //     variableWidth: true,
                //     centerMode: false,
                //     infinite: true,
                //     arrows: false,
                //     slidesToScroll: 1,
                // });

                $('.homepage-products .types .categories .category').on('click', function(){
                    $("html, body").animate(
                        {
                            scrollTop: $('.product-sliders').offset().top - 70,
                        },
                        1200
                    );
                });
            }

        },

        heroSlider: function () {
            $(".hero-slider").slick({
                prevArrow: '<span class="prev"></span>',
                nextArrow: '<span class="next"></span>',
                dots: true,
                autoplay: true,
                autoplaySpeed: 9000,
                speed: 1200,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                        },
                    },
                ],
            });
            $(".hero-slider, .main-photo").on("afterChange", function (event, slick, currentSlide, nextSlide) {
                $(".slick-slider video").each(function () {
                    let mediaObject = $(this)[0];
                    mediaObject.pause();
                });
                let video = $('[data-slick-index="' + currentSlide + '"] video');
                if (video.length == 1) {
                    video = video[0];
                    video.play();
                }
            });
        },

        productsSlider: function () {
            $(".products-slider:not(.action-products)").slick({
                prevArrow: '<span class="prev"></span>',
                nextArrow: '<span class="next"></span>',
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 1080,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: true,
                            centerMode: true,
                            infinite: true,
                            arrows: false,
                        },
                    },
                ],
            });

            $('.action-products').slick({
                prevArrow: '<span class="prev"></span>',
                nextArrow: '<span class="next"></span>',
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: true,
                            centerMode: true,
                            infinite: true,
                            arrows: false,
                        },
                    },
                ],
            });

            $(".variations_thumbnails").slick({
                prevArrow: '<span class="prev"></span>',
                nextArrow: '<span class="next"></span>',
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                ],
            });
        },

        brandsSlider: function () {
            if ($(window).width() > 992) {
                $(".brands-slider").slick({
                    prevArrow: '<span class="prev"></span>',
                    nextArrow: '<span class="next"></span>',
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: false,
                });

                $(".brands-slider .slick-current").addClass("opaque");
                $(".brands-slider .slick-current").next().addClass("opaque");
                $(".brands-slider .slick-current").next().next().addClass("opaque");

                $(".brands-slider").on("afterChange", function () {
                    $(".brand.slick-slide").removeClass("opaque");
                    $(".slick-current").addClass("opaque");
                    $(".slick-current").next().addClass("opaque");
                    $(".slick-current").next().next().addClass("opaque");
                });
            }

            $('section.homepage-brands .logotypes-loop.brands').slick({
                slidesToShow: 6,
                slidesToScroll: 1,   
                prevArrow: '<span class="prev"></span>',
                nextArrow: '<span class="next"></span>',
                autoplay: true,
                responsive: [
                    {
                        breakpoint: 1080,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            arrows: false,
                        },
                    },
                ]
            });
        },

        inspirationsSlider: function () {
            $("#slider .slider").slick({
                prevArrow: '<span class="prev"></span>',
                nextArrow: '<span class="next"></span>',
                autoplay: false,
            });

            $("#slider .slider").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                $(".slick-slider video").each(function () {
                    let mediaObject = $(this)[0];
                    mediaObject.pause();
                });
            });

            $("#slider a.poster, .media-wrap a.poster").click(function (e) {
                e.preventDefault();
                $(this).fadeOut();
                let video = $(this).parent().find("video");
                video.css("opacity", "1");

                video[0].play();
            });
        },

        productImages: function () {
            $(".main-photo").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                asNavFor: ".thumbnails",
                prevArrow: '<span class="prev"></span>',
                nextArrow: '<span class="next"></span>',
            });
            $(".thumbnails").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: ".main-photo",
                arrows: false,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                ],
            });
            $(".thumbnails").each(function () {
                var $this = $(this);
                if ($this.find(".thumb").length < 5) {
                    $this.addClass("blocked");
                }
            });
        },

        postsSlider: function () {
            $(".featured-slider").slick({
                prevArrow: '<span class="prev"></span>',
                nextArrow: '<span class="next"></span>',
                autoplay: false,
            });
        },

        arrowsWrap: function () {
            $(".slick-slider").each(function () {
                $(this).find(".slick-arrow").wrapAll('<div class="slider-nav"></div>');
            });
        },

        ajaxContent: function () {
            this.reloadAjaxContents();
        },

        reloadAjaxContents: function () {
            var _this = this;
            $("[data-ajax_content]").each(function () {
                _this.reloadAjaxContent($(this));
            });

            $(document).on("change", "[data-ajax_sort]", function () {
                const id = $(this).data("ajax_sort");
                _this.reloadAjaxContentById(id);
            });

            $(document).on("change", "[data-ajax_filter] input", function () {
                const id = $(this).closest("[data-ajax_filter]").data("ajax_filter");

                $(this).parent().toggleClass("checked");

                if ($(this).is(":checkbox")) {
                    var checked = $(this).is(":checked");
                    var filterContainer = $(this).closest("[data-ajax_filter]");
                    if (filterContainer.data("ajax_relation") == "or") {
                        filterContainer.find('input[type="checkbox"]:visible').prop("checked", false);
                        $(this).prop("checked", checked);
                    }
                }

                _this.reloadAjaxContentById(id);
            });

            $(document).on("click", "[data-ajax_pagination] [data-ajax_page]", function (e) {
                e.preventDefault();
                if ($(this).hasClass("current")) return;
                const id = $(this).closest("[data-ajax_pagination]").data("ajax_pagination");
                const page = $(this).data("ajax_page");
                _this.reloadAjaxContentById(id, page);
            });

            $(document).on("click", "[data-clear_filters]", function (e) {
                e.preventDefault();
                const id = $(this).closest("[data-ajax_filter]").data("ajax_filter");
                $(this)
                    .closest("[data-ajax_filter]")
                    .find("[data-filter_field]")
                    .each(function () {
                        if ($(this).is(":checked")) {
                            $(this).prop("checked", false);
                        }
                    });
                _this.reloadAjaxContentById(id);
            });
        },

        reloadAjaxContentById(id, page) {
            var _this = this;
            const element = $(`[data-ajax_content="${id}"]`);
            _this.reloadAjaxContent(element, page);
        },

        reloadAjaxContent: function (element, page) {
            if (!page) page = 1;

            var _this = this;

            if (!element.hasClass(_this.ajaxLoadingClass)) {
                element.addClass(_this.ajaxLoadingClass);
            }

            var id = element.data("ajax_content");
            var args = this.buildAjaxContentArgs(id, page);

            _this.xhr = $.ajax({
                url: themeSettings.ajaxurl,
                dataType: "html",
                method: "post",
                data: args,
                beforeSend: function () {
                    if (_this.xhr) {
                        _this.xhr.abort();
                    }
                },
                success: function (response) {
                    element.html(response);
                    element.removeClass(_this.ajaxLoadingClass);
                    //_this.masonry();
                },
            });
        },

        buildAjaxContentArgs: function (id, page) {
            var args = {
                action: null,
                content: null,
                relation: "or",
                filters: {
                    taxonomy: {},
                },
                sort: null,
            };

            args.action = "get_ajax_content";
            args.content = id;
            args.page = page;
            args.relation = $(`[data-ajax_filter="${id}"]`).data("ajax_relation");

            args.sort = $(`[data-ajax_sort="${id}"]`).val();

            var filtersCounter = 0;

            $(`[data-ajax_filter="${id}"] [data-filter_field]:checked`).each(function () {
                const tax = $(this).data("taxonomy");
                const term_id = $(this).data("term_id");
                if (!args.filters.taxonomy[tax]) {
                    args.filters.taxonomy[tax] = [];
                }
                args.filters.taxonomy[tax].push(term_id);
                filtersCounter++;
            });

            $(`[data-ajax_filter="${id}"]`).find("[data-filters_count]").html(`(${filtersCounter})`);
            var filtersHeader = $(`[data-ajax_filter="${id}"]`).find(".filters-header");
            if (filtersCounter > 0) {
                filtersHeader.removeClass("hidden");
            } else {
                filtersHeader.addClass("hidden");
            }

            this.buildUrl(args);

            return args;
        },

        buildUrl: function (args) {},

        toggleFilters: function () {
            if ($(window).width() < 769) {
                $(".taxonomy-filter-checkbox h3").click(function () {
                    $(".taxonomy-filter-terms-container").fadeOut();
                    $(this).parent().find(".taxonomy-filter-terms-container").toggle();
                });
            }
        },


        tabs: function () {
            $("#tabs").tabs();
            // $("#summery_tabs").tabs();

            $(".product-accordion").accordion({
                collapsible: true,
                heightStyle: "content",
                active: false
            });

            $(".homepage-products .types").tabs({
                activate: function(event, ui) {
                    ui.newPanel.find('.products-slider').slick('setPosition');
                }
            });
        },

        filters: function () {
            $("ul.woocommerce-widget-layered-nav-list").closest(".widget").addClass("cat-filters");

            $(".cat-filters h3").click(function () {
                $(this).parent().toggleClass("opened");
            });

            $("ul.woocommerce-widget-layered-nav-list li").each(function () {
                if ($(this).hasClass("chosen")) {
                    $(this).parent().parent().addClass("opened");
                }
            });

            if ($(window).width() < 769) {
                $(".content-area.with-sidebar.product-archive .sidebar").prepend(
                    '<a href="#" class="show-filters btn solid">Pokaż filtry</a>'
                );

                $("a.show-filters").click(function (e) {
                    e.preventDefault();
                    $(this).toggleClass("opened");
                    $(this).next().toggle();

                    if ($(this).hasClass("opened")) {
                        $(this).html("Ukryj filtry");
                    } else {
                        $(this).html("Pokaż filtry");
                    }
                });
            }
        },

        backToTop: function () {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 1200) {
                    $("#scrollToTopBtn").addClass("visible");
                } else {
                    $("#scrollToTopBtn").removeClass("visible");
                }
            });

            var scrollToTopBtn = document.getElementById("scrollToTopBtn");
            var rootElement = document.documentElement;

            function scrollToTop() {
                rootElement.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }
            scrollToTopBtn.addEventListener("click", scrollToTop);
        },

        share: function () {
            $(".actions a.share").click(function (e) {
                e.preventDefault();
                $(this).parent().find(".addtoany_shortcode").fadeIn();
            });
        },

        upload: function () {
            $(":file").jfilestyle({
                text: '<span class="plus">+</span>',
                inputSize: "100%",
            });

            $("input[type=file]").change(function () {
                if ($(this).val()) {
                    $(this).parent().addClass("file-in");
                } else {
                    $(this).parent().removeClass("file-in");
                }
            });
        },


    };
})(jQuery);
